class SwiperCarousel extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      swiper: ".swiper",
      swiperWrapper: ".swiper-wrapper",
      swiperSlide: ".swiper-slide",
    };
  }

  connectedCallback() {
    this.elements = {
      swiper: this.querySelector(this.selectors.swiper),
      swiperWrapper: this.querySelector(this.selectors.swiperWrapper),
      swiperSlide: this.querySelector(this.selectors.swiperSlide),
    };

    if (this.elements.swiper) {
      this.initSwiper = this.initSwiper.bind(this);
      this.initSwiper();
    }
  }

  initSwiper() {
    const slidesPerView = this.dataset.slidesPerView || 1;
    const spaceBetween = this.dataset.spaceBetween || 10;
    const mobileSlidesPerView = this.dataset.mobileSlidesPerView || 1;
    const mobileSpaceBetween = this.dataset.mobileSpaceBetween || 10;
    const pagination = this.dataset.pagination === "true";
    const autoplay = this.dataset.autoplay === "true" || false;
    const autoplayDelay = this.dataset.autoplayDelay || 5000;
    const centeredSlides = this.dataset.centeredSlides === "true" || false;
    const loop = this.dataset.loop === "true" || false;
    const progressbar = this.querySelector(".swiper-progress");
    const navigation = {
      nextEl: this.dataset.nextButton,
      prevEl: this.dataset.prevButton,
    };
    const effect = this.dataset.effect || "slide";

    const configObject = {
      centeredSlides: centeredSlides,
      loop: loop,
      slidesPerView: mobileSlidesPerView,
      spaceBetween: mobileSpaceBetween,
      breakpoints: {
        1024: {
          slidesPerView: slidesPerView,
          spaceBetween: spaceBetween,
          centeredSlides: false,
        },
      },
      navigation: navigation,
      effect: effect,
      pagination: {
        el: progressbar,
        type: "progressbar",
      },
    };
    autoplay &&
      (configObject.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
      });

    this.swiper = new Swiper(this.elements.swiper, configObject);

    pagination && this.setupPagination();
  }

  setupPagination() {
    const paginationElements = this.querySelectorAll(".hero__dot");
    paginationElements.forEach((element, index) => {
      element.addEventListener("click", () => {
        this.swiper.slideTo(index);
      });
    });

    this.swiper.on("slideChange", () => {
      paginationElements.forEach((element, index) => {
        element.classList.remove("hero-dot--active");
        if (index === this.swiper.realIndex) {
          element.classList.add("hero-dot--active");
        }
      });
    });
  }
}

customElements.define("swiper-carousel", SwiperCarousel);
